import React, { useEffect, useState } from 'react';
import OptimizedImage from '../OptimizedImage';

/**
 * Initial counter phases:
 * 0 - load first photo, start first animation
 * 1 - load second photo, if not loaded
 * 2 - start second animation
 * 3 - load third photo, if not loaded
 * 4 - start third animation
 */
const HomeBackgroundReel = ({ children }) => {
  const [mounted, setMounted] = useState(true);
  const [photosState, setPhotosState] = useState({
    allLoaded: false,
    counter: 0
  });

  const updateCounter = () => {
    if (mounted) {
      setPhotosState(oldState => {
        const { counter, allLoaded } = oldState;
        const newCounter = (counter + 1) % 6;
        const newLoaded = allLoaded || newCounter === 4;
        return {
          allLoaded: newLoaded,
          counter: newCounter
        };
      });
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      updateCounter();
    }, 3000);
    return () => {
      setMounted(false);
      clearInterval(interval);
    };
  }, []);

  const getClasses = index => {
    // continue with active clas for current phase and 3 more, f.e. if animation starts at 2,
    // active class will be present for phases 2, 3, 4, 5.
    return [index, (index + 1) % 6, (index + 2) % 6, (index + 3) % 6].includes(
      photosState.counter
    )
      ? 'active'
      : '';
  };
  return (
    <div className="body-header home-background-reel">
      <div
        className="img-test position-absolute"
        style={{ width: '100%', height: '100%' }}
      >
        <OptimizedImage
          src="main-header/screen.jpg"
          alt="Wroclaw"
          title="Wroclaw city"
          style={{ width: '100%', height: '100%' }}
        />
      </div>
      {/* <div className={`photo ${getClasses(0)}`}>
        <OptimizedImage
          src="main-header/wro.jpg"
          alt="Wroclaw"
          title="Wroclaw city"
          style={{
            objectPositionY: 'top' // position Y depends on the photo, what looks better etc.
          }}
        />
      </div> */}
      {/* <div className={`photo ${getClasses(2)}`}>
        {(photosState.allLoaded || photosState.counter >= 1) && (
          <OptimizedImage
            src="main-header/screen.jpg"
            alt="work in Ulam"
            title="work in Ulam Labs"
            style={{
              objectPositionY: 'center'
            }}
          />
        )}
      </div>
      <div className={`photo ${getClasses(4)}`}>
        {(photosState.allLoaded || photosState.counter >= 3) && (
          <OptimizedImage
            src="main-header/young.jpg"
            alt="office"
            title="Ulam Labs office"
            style={{
              objectPositionY: 'center'
            }}
          />
        )}
      </div> */}
      {children}
    </div>
  );
};

export default HomeBackgroundReel;
